

import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Plus, Trash2 } from "lucide-react";
import AddItemType from "./InventoryModals/AddItemType";
import { API_BASE_URL } from "../../app/apiConfig";

export default function InventoryTypes() {
  const [itemTypes, setItemTypes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const getItemTypes = async () => {
    const token = Cookies.get("token");
    try {
      const res = await axios.get(
        `${API_BASE_URL}/inventory/types`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data?.success) {
        setItemTypes(res.data.data.sort((a, b) => a.id - b.id));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this item type?")) return;

    setDeletingId(id);
    const token = Cookies.get("token");

    try {
      const res = await axios.delete(
        `${API_BASE_URL}/inventory/types/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data?.success) {
        setItemTypes((prev) => prev.filter((i) => i.id !== id));
      }
    } catch {
      alert("Delete failed");
    } finally {
      setDeletingId(null);
    }
  };

  useEffect(() => {
    getItemTypes();
  }, []);

  return (
    <>
      <div
        className="
        rounded-2xl md:mt-20 p-5
        bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f]
        text-white border border-white/10 shadow-2xl
      "
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold">
            Inventory Types
          </h1>

          <button
            onClick={() => setIsModalOpen(true)}
            className="
              flex items-center gap-2
              bg-purple-600 hover:bg-purple-500
              px-4 py-2 rounded-lg text-sm whitespace-nowrap
            "
          >
            <Plus size={16} />
            Add Item Type
          </button>
        </div>

        {/* Table container */}
        <div className="border border-white/10 rounded-xl bg-white/5">
          <table className="w-full text-sm text-center">
            <thead className="text-white/70 border-b border-white/10">
              <tr>
                <th className="py-3">ID</th>
                <th>Item Type</th>
                <th>Assignable</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {itemTypes.length === 0 && (
                <tr>
                  <td colSpan="4" className="py-10 text-white/50">
                    No item types found
                  </td>
                </tr>
              )}

              {itemTypes.map((item) => (
                <tr
                  key={item.id}
                  className="border-b border-white/5 hover:bg-white/5"
                >
                  <td className="py-3">{item.id}</td>

                  <td className="font-medium">
                    {item.item_type}
                  </td>

                  <td>
                    <span
                      className={`px-3 py-1 rounded-full text-xs ${
                        item.user_assignable
                          ? "bg-green-500/20 text-green-300"
                          : "bg-red-500/20 text-red-300"
                      }`}
                    >
                      {item.user_assignable ? "YES" : "NO"}
                    </span>
                  </td>

                  <td>
                    <button
                      onClick={() => handleDelete(item.id)}
                      disabled={deletingId === item.id}
                      className="text-red-400 hover:text-red-300"
                    >
                      {deletingId === item.id ? "..." : <Trash2 size={16} />}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <AddItemType
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          getItemTypes();
        }}
      />
    </>
  );
}
